import React from 'react';

import Highlight from 'common/developers/docs/api/Highlight';
import Text, { H2, P } from 'common/ui/Text';

import APIDocsBlock from '../APIDocsBlock';

const APIDocsPaginationBlock = () => {
  return (
    <APIDocsBlock>
      <div>
        <H2 className="heading" fontWeight="regular">
          Pagination
        </H2>
        <P className="textMargin">
          Endpoints which list many results will have a limit on the number of results that can be
          returned, and pagination is the mechanism to retrieve results beyond that limit. To fetch
          more results, make a subsequent request with the necessary pagination parameters.
        </P>
        <P className="textMargin">There are two approaches to pagination in the Canny API:</P>
        <ul className="list">
          <Text as="li" className="listTextMargin">
            <Text as="strong" fontWeight="bold">
              Cursor
            </Text>
            : Request returns a cursor, which is used to fetch the next page.
          </Text>
          <Text as="li" className="textMargin">
            <Text as="strong" fontWeight="bold">
              Skip
            </Text>
            : The skip parameter allows you to bypass the first N results.
          </Text>
        </ul>
        <P className="textMargin">
          Not all endpoints use the same approach, review the documentation for each endpoint to
          understand how to paginate.
        </P>
      </div>
      <div>
        <div className="text">Cursor pagination:</div>
        <Highlight lang="shell">{cursorSnippet}</Highlight>
        <div className="text">Skip pagination:</div>
        <Highlight lang="shell">{skipSnippet}</Highlight>
      </div>
    </APIDocsBlock>
  );
};

const cursorSnippet = `
$ curl https://canny.io/api/v2/users/list \\
    -d apiKey=YOUR_API_KEY \\
    -d cursor=NTUzYzNlZjhiOGNkY2QxNTAxYmExMjNhXzIwMjUtMDItMDRUMTY6NDA6MDcuNTQxWl8x \\
    -d limit=10`.trim();

const skipSnippet = `
$ curl https://canny.io/api/v1/posts/list \\
    -d apiKey=YOUR_API_KEY \\
    -d skip=10 \\
    -d limit=10`.trim();

export default APIDocsPaginationBlock;
